/* eslint-disable @typescript-eslint/no-explicit-any */

import type { EnvironmentConfig } from "@acadv/shared/services";

declare const WebConfig: any;

export const DefaultConfig = {} as EnvironmentConfig;

/**
 * Service to load and provide external configuration from WebConfig
 * This is loaded from environment.*.js files at runtime
 * 
 * Note: This service is a static utility class with no Angular dependencies.
 * It's used in main.ts before the async bootstrap boundary.
 */
export class ExternalConfigService {
  private static _config: EnvironmentConfig;

  static get Config(): EnvironmentConfig {
    return this._config || DefaultConfig;
  }

  private static _createConfig(config: any): EnvironmentConfig {
    const _config = { ...DefaultConfig, ...(<EnvironmentConfig>config) };
    ExternalConfigService._config = _config;
    return _config;
  }

  static loadAppConfig(): void {
    this._createConfig(WebConfig);
  }
}

